import { t } from '@if/core/i18n'
import LaunchIcon from '@mui/icons-material/Launch'
import { Box, Grid, IconButton, Typography, useTheme } from '@mui/material'
import { NormsMessage } from '@src/data/types'
import WarningMessageList from './warningMessageList'

interface Props {
  applicantWarningMessage: NormsMessage[] | null | undefined
  coapplicantWarningMessage: NormsMessage[] | null | undefined
}

const FraudWarningMessageList = ({ applicantWarningMessage, coapplicantWarningMessage }: Props) => {

  const theme = useTheme()
  const borderColor = theme.palette.divider

  const applicantHasFraudWarning = applicantWarningMessage != null && applicantWarningMessage.length > 0
  const coapplicantHasFraudWarning = coapplicantWarningMessage != null && coapplicantWarningMessage.length > 0
  const size = applicantHasFraudWarning && coapplicantHasFraudWarning ? 'half' : null

  if (!applicantHasFraudWarning && !coapplicantHasFraudWarning) return null
  return (
    <Grid
      size={{
        xs: 12,
        md: 12,
        lg: 12,
      }}
    >
      <Box
        sx={{
          border: '1px solid',
          borderColor,
          borderRadius: 2,
          p: 1,
        }}
      >
        <Typography>
          {t('fraudFlags.label')}
          <IconButton aria-label="launch" color="primary" size="small" href="../fraud-flags" target="_blank">
            <LaunchIcon />
          </IconButton>
        </Typography>
        <Grid container columnSpacing={2}>
          {applicantHasFraudWarning && (
            <WarningMessageList normsMessages={applicantWarningMessage} size={size} messageTitle={''} />
          )}
          {coapplicantHasFraudWarning && (
            <WarningMessageList normsMessages={coapplicantWarningMessage} size={size} messageTitle={''} />
          )}
        </Grid>
      </Box>
    </Grid>
  )
}

export default FraudWarningMessageList
